import { render } from "./PaymentV2Confirm.vue?vue&type=template&id=d52f37ea"
import script from "./PaymentV2Confirm.vue?vue&type=script&lang=js"
export * from "./PaymentV2Confirm.vue?vue&type=script&lang=js"

import "./PaymentV2Confirm.vue?vue&type=style&index=0&id=d52f37ea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__